function ItemDotBlueComponent(props) {
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  )
    return (
      <>
        {props.item.cnt < 2 && <div className="dotBlue"></div>}

        {props.item.cnt >= 2 && (
          <div className="dotBlueMed">{props.item.cnt}</div>
        )}
      </>
    );
  else return null;
}

export { ItemDotBlueComponent };
